/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import { useTranslation } from "react-i18next";

const AutomationTemplateHeader = ({ reloadList = () => {} }) => {
  /* ---- bread crumb text ---- */
  const breadcrumbText = [{ title: "Automation Templates" }];

  const { t } = useTranslation();

  return (
    <div className="filter-container py-3">
      <div className="row align-items-center">
        <div className="col-md-2 col-lg-2 d-none d-md-block mb-3 mb-md-0">
          {/* --- breadcrumb start --- */}
          <BreadCrumb breadCrumbText={breadcrumbText} top={false} />
          {/* --- breadcrumb end --- */}
        </div>
        <div className="col-md-10 col-lg-10 d-flex justify-content-end gap-1 gap-sm-2">
          <Link
            onClick={reloadList}
            to="#"
            className="btn btn-gray d-flex align-items-center"
          >
            <span className="d-block material-symbols-outlined icon-md">
              refresh
            </span>
          </Link>

          <button
            type="button"
            className="btn btn-gray d-flex align-items-center gap-1"
            data-bs-toggle="offcanvas"
            data-bs-target="#automationTemplateFilter"
            aria-controls="automationTemplateFilter"
          >
            <span className="d-block material-symbols-outlined icon-md">
              filter_list
            </span>
            <span className="d-none d-sm-block">{t("Filter")}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AutomationTemplateHeader;
